import { useLocation } from 'react-router-dom'
import getCurrentRoute from '../utils/getCurrentRoute'

const useRoute = () => {
    const location = useLocation()
    return getCurrentRoute(location.pathname)
}

export default useRoute
